import React from 'react';
import { SortAccessor } from './types';

export function useOnReachBottom(callback: () => void, enabled: boolean = true) {
  React.useEffect(() => {
    if (!enabled) return;
    const handler = () => {
      if (window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight) {
        callback();
      }
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, [enabled]);
}

export function sortDevices<T>(items: T[], accessor: SortAccessor<T>, asc: boolean): T[] {
  const direction = asc ? 1 : -1;

  const compare = (a: T, b: T) => {
    const va = accessor(a);
    const vb = accessor(b);

    if (va == null && vb == null) return 0;
    if (va == null) return 1;
    if (vb == null) return -1;

    if (typeof va === 'string' && typeof vb === 'string') {
      return va.localeCompare(vb) * direction;
    }
    return (va < vb ? -1 : va > vb ? 1 : 0) * direction;
  };

  return [...items].sort(compare);
}
